import { useSelector } from "react-redux";
import { useEffect } from "react";
import { webTitle } from "../config/configmap";

function GlobalTitleSetter() {
  const currentConfig = useSelector((state) => state.configData);

  useEffect(() => {
    if (currentConfig) {
      document.title = webTitle;
    }
  }, [currentConfig]);

  return null;
}

export default GlobalTitleSetter;
